import { Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '&.FLIDialogFloatingLocation': {
    '&.MuiDialog-root': {
      position: 'absolute',
      bottom: theme.typography.pxToRem(144),
      left: theme.typography.pxToRem(14),
      zIndex: theme.zIndex.appBar - 1,

      [theme.breakpoints.down('lg')]: {
        bottom: theme.spacing(-11.4),
      },
    },

    '& .MuiDialog-paper': {
      borderRadius: '4px',
      backgroundColor: theme.palette.background.default,
      overflowY: 'unset',
      width: theme.spacing(52.125),
      [theme.breakpoints.down('lg')]: {
        width: theme.spacing(36.25),
      },
    },
    '& .MuiDialogContent-root': {
      paddingBottom: '0px',
      padding: theme.spacing(0, 2),
    },

    '& .MuiDialogActions-root': {
      padding: theme.spacing(0, 2, 1),
    },

    '& .FLIBookbtn': {
      [theme.breakpoints.down('lg')]: {
        width: '100%',
      },
    },

    '& .FLIBtnPos': {
      marginLeft: 'auto',
      [theme.breakpoints.down('lg')]: {
        width: '100%',
      },
    },

    '& .FLILocDetails': {
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      '& .FLILocDetailsIcon': {
        width: theme.spacing(2),
        height: theme.spacing(2),
      },
    },
    '& .FLILocationDetailsBtn': {
      color: theme.palette.primary.main,
    },
    '& .FLILocbtn': {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: '700',
      letterSpacing: 0.105,
      paddingRight: theme.spacing(0.25),
      textTransform: 'uppercase',
      textDecoration: 'underline',
      borderRadius: '0 !important',
    },
    '& .FLIBadge': {
      width: theme.typography.pxToRem(50.75),
      height: theme.typography.pxToRem(49.88),
      [theme.breakpoints.down('md')]: {
        width: theme.spacing(4.25),
        height: theme.spacing(3.15),
      },
    },
    '& .FLIDialog': {
      color: theme.palette.common.white,
      '&.FLIDialogHeader': {
        padding: theme.spacing(2, 7, 1.5, 2),
        position: 'relative',
      },
    },
    '& .FLIInfoContent': {
      '& a': {
        textDecorationColor: theme.palette.common.white,
      },
    },
    '& .FLIGridShrink': {
      flexShrink: 0,
    },
    '& .FLITRI': {
      height: '0',
      width: '0',
      position: 'absolute',
      bottom: theme.spacing(-1.625),
      left: '50%',
      borderTop: `${theme.spacing(1.625)} solid ${theme.palette.grey[500]}`,
      borderLeft: `${theme.spacing(1.125)} solid transparent`,
      borderRight: `${theme.spacing(1.125)} solid transparent`,
      [theme.breakpoints.down('lg')]: {
        display: 'none',
      },
    },
    '& .FLICloseBtn': {
      fill: theme.palette.common.white,
      padding: 0,
      position: 'absolute',
      top: theme.spacing(2),
      right: theme.spacing(2),
    },
    '& .FLITitle': {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      gap: theme.spacing(2),
      flexDirection: 'row',
    },
    '& .FLITextGrid': {
      flexGrow: 1,
      whiteSpace: 'warp',
    },
    '& .FLILocationText': {
      fontFamily: 'DrukText',
      fontWeight: 700,
      letterSpacing: '.12px',
    },
    '& .FLIERBadge': {
      color: theme.palette.common.black,
      fontSize: theme.spacing(1.25),
      fontWeight: 700,
      marginRight: theme.spacing(1),
      backgroundColor: theme.palette.primary.main,
      borderRadius: theme.spacing(1.5),
      padding: theme.spacing(0.5, 0.75, 0.25, 0.75),
      whiteSpace: 'nowrap',
      position: 'relative',
      top: theme.spacing(-0.5),
    },
    '& .FLIBsadgeAndName': {
      overflowWrap: 'anywhere',
    },
  },
}));
export default StyledDialog;
